import { Stack, TextField } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import { CrudPage } from '../../shared/components/CrudPage';
import { resources } from '../../core/services/resources';
import type { Tenant } from '../../core/types/data-models';
import { TenantUsersSection } from './TenantUsersSection';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 80 },
  { field: 'name', headerName: 'Name', flex: 1, minWidth: 220 },
];

export function TenantsPage() {
  return (
    <CrudPage<Tenant>
      title="Tenants"
      entityName="Tenant"
      description="Each tenant is an isolated data partition. Switch between them via the sidebar."
      cacheKey={['tenants']}
      service={resources.tenants}
      columns={columns}
      defaultValues={{ name: '' }}
      renderForm={({ values, setValues }) => (
        <Stack spacing={2}>
          <TextField
            label="Name"
            required
            value={values.name ?? ''}
            onChange={(e) => setValues({ ...values, name: e.target.value })}
          />
          {values.id != null && <TenantUsersSection tenantId={values.id} />}
        </Stack>
      )}
    />
  );
}
